import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import { GAME_IMAGES_KEY } from '../gameData';

export default class NumberSelectButton extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, num) {
    super(scene);

    this.num = num;

    this.bg = ABCyaPhaser.Images.addImage(0,0,'NumberSelectButtonBackground', this, GAME_IMAGES_KEY).setOrigin(0);

    ABCyaPhaser.Container.setContainerInteractive(this, false);

    if (this.num === 13) {
      // add question mark
      this.lblNum = ABCyaPhaser.Images.addImage(0,0,'QuestionMark', this, GAME_IMAGES_KEY).setScale(0.75);

      this.lblNum.x = this.bg.width / 2 - 3;
      this.lblNum.y = this.bg.height / 2 - 3;
    }
    else {
      const dn = this.num.toString();
      this.lblNum = ABCyaPhaser.Text.addText(0,0, '58pt', 0x000000, FontKeys._cf_samurai_bobregular, dn, this, true).setOrigin(0.5);

      this.lblNum.x = this.bg.width / 2 - 3;
      this.lblNum.y = this.bg.height / 2 - 11;
    }
  }
}